import { User } from '@instamenu/data-access';
import { Emoji } from '../emoji/emoji';
import { AvatarStyled } from './avatar.css';
import { Box } from '../box/box';
import Image from 'next/image';

type AvatarUser = Pick<User, 'id' | 'name' | 'avatarUrl'>;

export type AvatarProps = {
  size?: number;
  user: AvatarUser;
};

const emojis = ['😎', '🥸', '🤩', '🥳', '😏', '😋', '🤓', '😶‍🌫️', '😊', '😜'];

function idToEmoji(id: string) {
  return emojis[
    (id
      ?.split('')
      .map((char) => char.charCodeAt(0))
      .reduce((sum, v) => sum + v) ?? 0) % emojis.length
  ];
}

const StyledBox = ({ children, css }: { children: React.ReactNode; css?: React.CSSProperties }) => {
  return (
    <Box style={css} className={AvatarStyled}>
      {children}
    </Box>
  );
};

export function Avatar({ user, size = 34 }: AvatarProps) {
  const emoji = idToEmoji(user?.id);
  return (
    <StyledBox css={{ width: size, height: size, lineHeight: size }} data-component="Avatar">
      {user?.avatarUrl ? (
        <Image src={user.avatarUrl} alt={user.name ?? 'Avatar'} width={size} height={size} />
      ) : (
        <Box style={{ fontSize: size / 1.65 + 'px' }}>
          <Emoji emoji={emoji} ariaLabel="Avatar" />
        </Box>
      )}
    </StyledBox>
  );
}

export default Avatar;
